import Text_module_default from "./Text.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
import { Control } from "@radix-ui/react-form";
//#region src/components/Form/Controls/Text/Text.tsx
/**
* A styled text input, for standalone use.
*/
var TextInput = forwardRef(function TextInput({ className, enableLigatures, ...props }, ref) {
	const classes = classNames(Text_module_default.control, className, { [Text_module_default["enable-ligatures"]]: enableLigatures });
	return /* @__PURE__ */ jsx("input", {
		ref,
		...props,
		className: classes
	});
});
/**
* A styled text input wrapped in a `Control` component, for use in Radix forms.
*/
var TextControl = forwardRef(function TextControl(props, ref) {
	return /* @__PURE__ */ jsx(Control, {
		asChild: true,
		children: /* @__PURE__ */ jsx(TextInput, {
			ref,
			...props
		})
	});
});
//#endregion
export { TextControl, TextInput };

//# sourceMappingURL=Text.js.map